import { Button, Col, Row, Space } from "antd"
import { StyledForm } from "./styles"
import React, { forwardRef, useEffect, useState } from "react"
import PortalSelect from "./Components/PortalSelect";
import PortalInputText from "./Components/PortalInputText";
import PortalInputUpload from "./Components/PortalInputUpload";
import PortalDatePicker from "./Components/PortalDatePicker";
import PortalDatePeriodPicker from "./Components/PortalDatePeriodPicker";
import ObjectUtils from "utils/objects";
import PortalRadio from "./Components/PortalRadio";
import PortalCheckboxGroup from "./Components/PortalCheckboxGroup";
import PortalCheckbox from "./Components/PortalCheckbox";
import PortalInputSufixos from "./Components/PortalInputSufixos";
import PortalInputTable from "./Components/PortalInputTable";


const Formulario = (({formReference, inputsData, ...props}) => {
    const [submittable, setSubmittable] = useState(false);
    const [isMounted, setIsMounted] = useState(true);
    const [inputs, setInputs] = useState([]);
    const values = StyledForm.useWatch([], formReference);
    const [propsInputs, setPropsInputs] = useState({empty:null});
    const [submitButtonStyle, setSubmitButtonStyle] = useState({columnSpan: 1, itemOffset: 8, itemSpan: 16});
    const [inputSpaceSize, setInputSpaceSize] = useState("small");
    
    useEffect(() => {
        if (props.initialValues) {
            formReference.setFieldsValue(props.initialValues);
        }
    }, [props.initialValues]);
    
    useEffect(()=>{
        if (props.submitButtonAlign == "center"){
            setSubmitButtonStyle({columnSpan: 24, itemOffset: 11, itemSpan: 24});
        }

        if (props.inputSpaceSize) {
            setInputSpaceSize(props.inputSpaceSize);
        }

        return () => {
            setIsMounted(false);
        };

    },[])
    
    useEffect(()=>{
        if(!isMounted){
            return;
        }
        if(inputsData.length > 0){
            if(!ObjectUtils.objetosSaoIguais(inputsData, propsInputs)){
                setPropsInputs(inputsData)
                GenerateInputs();
            }
        }
    },[inputsData])
    
    useEffect(() => {
        ValidateSubmitable();
    }, [values]);

    const ValidateSubmitable = () => {
        formReference.validateFields({ validateOnly: true }).then(
            (values) => {
                
                if(!isMounted || Object.keys(values).length == 0){
                    return;
                }
                setSubmittable(true);
                if(props.onSubmitableChange != null && typeof (props.onSubmitableChange) == "function"){
                    props.onSubmitableChange(true);
                }
            }).catch(()=>{
                setSubmittable(false);
                if(props.onSubmitableChange != null && typeof (props.onSubmitableChange) == "function"){
                    props.onSubmitableChange(false);
                }
            });
    }

    const GenerateInputs = () => {
        let data = [];
        inputsData.forEach(inputData => {
            switch (inputData.input?.type || inputData.type) {
                case 'text':
                case 'textarea':
                case 'phone':
                    data.push(<PortalInputText key={inputData.input.name} {...inputData} form={formReference} inputColSpan={props.inputColSpan || null}/>)
                    break;
                case 'textSufixos':
                    data.push(<PortalInputSufixos key={inputData.input.name} {...inputData} form={formReference} portalOnInputSufixosValueChange={props.portalOnInputSufixosValueChange || null} inputColSpan={props.inputColSpan || null} />)
                    break;
                case 'date':
                    data.push(<PortalDatePicker key={inputData.input.name} {...inputData} form={formReference} inputColSpan={props.inputColSpan || null}/>)
                    break;
                case 'dateperiod':
                    data.push(<PortalDatePeriodPicker key={inputData.input.name} {...inputData} form={formReference} inputColSpan={props.inputColSpan || null}/>)
                    break;
                case 'select':
                case 'selectSearch':
                case 'selectGroup':
                    data.push(<PortalSelect key={inputData.input.name} {...inputData} form={formReference} portalOnSelectValueChange={props.portalOnSelectValueChange || null} inputColSpan={props.inputColSpan || null} />)
                    break;
                case 'anexo':
                    data.push(<PortalInputUpload key={inputData.input.name} {...inputData} form={formReference} inputColSpan={props.inputColSpan || null}/>)
                    break;
                case 'radio':
                    data.push(<PortalRadio key={inputData.input.name} {...inputData} form={formReference} inputColSpan={props.inputColSpan || null}/>)
                    break;
                case 'checkbox':
                    data.push(<PortalCheckbox key={inputData.input.name} {...inputData} form={formReference} inputColSpan={props.inputColSpan || null}/>)
                    break;
                case 'checkboxGroup':
                    data.push(<PortalCheckboxGroup key={inputData.input.name} {...inputData} form={formReference} inputColSpan={props.inputColSpan || null}/>)
                    break;
                case 'table':
                    data.push(<PortalInputTable key={inputData.input.name} {...inputData} form={formReference} inputColSpan={props.inputColSpan || null} onValuesChange={props.onValuesChange} />)
                    break;
                default:
                    break;
            }
        })
        if(isMounted){
            setInputs(data);
        }
    }

    const onFinishFailed = (value) => {
        return props.onFinishFailed(value);
    }
    const onFinish = async (value) =>{
        return props.onFinish(value)
    }
    /**
     * Limpa os campos e retorna os valores anteriores do formulário
     * @returns 
     */
    const onClear = () =>{
        let oldValues = formReference.getFieldsValue();
        formReference.resetFields();
        return props.onClear(oldValues);
    }

    return(
        <div key="formulariokey">
            <StyledForm 
                form={formReference}
                onFinish={onFinish} 
                onFinishFailed={onFinishFailed}
                onFieldsChange={props.onFieldsChange}
                onValuesChange={props.onValuesChange}
                initialValues={props.initialValues}
                disabled={props.disabled || props.readOnly}
                layout="vertical"
            >
                <Row align={"middle"}>
                    <Col span={24} flex="none">
                        {props.image ? <img src={`data:image/jpeg;base64,${props.image}`} /> : ""}
                    </Col>
                    {props.title ? 
                        <Col flex="auto">
                            <h1>{props.title}</h1>
                        </Col>
                    : ""}
                </Row>
                <Row gutter={24} xs={{ flex: '100%' }}
                    sm={{ flex: '50%' }}
                    md={{ flex: '40%' }}
                    lg={{ flex: '20%' }}
                    xl={{ flex: '10%' }}>
                        {props.inputsSpace ? 
                            <Space direction={props.inputsSpace?.direction ?? "vertical"} size={props.inputsSpace?.inputSpaceSize ?? "small"}>
                                {inputs && inputs.map(x=>x)}
                            </Space>
                        :
                            <>
                                {inputs && inputs.map(x=>x)}
                            </>
                        }
                    {props.hideSubmitButton ? null : 
                        <Col span={submitButtonStyle.columnSpan} style={{alignSelf:"center"}} className="col-submit">
                            <StyledForm.Item wrapperCol={{ offset: submitButtonStyle.itemOffset, span: submitButtonStyle.itemSpan }} >
                                <Space direction={props.buttonHorizontal ? "horizontal" : "vertical"}>
                                    {
                                        props.showClearButton && (
                                        <Button onClick={onClear}>
                                            Limpar
                                        </Button>)
                                    }                                    

                                    <Button className="submitButton" type="primary" htmlType="submit" disabled={!submittable}> 
                                        {props.submitButtonMessage ?? "Confirmar"}
                                    </Button>

                                    {
                                        props.onCancel && (
                                            <Button onClick={props.onCancel}>
                                                Cancelar
                                            </Button>
                                        )
                                    }

                                </Space>
                            </StyledForm.Item> 
                        </Col>
                    }
                </Row>
                <div>
                    {props.formErrors?.length > 0 ? (
                        props.formErrors.map((erro, index) => (
                        <div key={index} style={{ color: 'red' }}>
                            {erro}
                        </div>
                        ))
                    ) : (
                        null
                    )}
                </div>
            </StyledForm>            
        </div>
    )
})

export default Formulario;